import { Component, Inject, OnInit, PLATFORM_ID, DOCUMENT } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { IconsService } from './shared/icons/icons.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SeoService } from './services/seo/seo.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    private iconsService: IconsService,
    private gtmService: GoogleTagManagerService,
    private router: Router,
    private seo: SeoService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.iconsService.registerIcons();
    if (isPlatformBrowser(this.platformId)) {
      this.gtmService.addGtmToDom();
    }
  }
  title = 'Aris';

  ngOnInit(): void {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        // DOCUMENT.location is populated by platform-server from the render
        // URL, so the canonical tag is emitted in the SSR HTML too.
        const origin = (
          this.document.location?.origin ?? environment.webUrl
        ).replace(/\/+$/, '');
        const url = origin + '/' + e.urlAfterRedirects.replace(/^\/+/, '');
        this.seo.setCanonical(url);
      });
  }
}
